import { render, staticRenderFns } from "./InstallmentExtensionModal.vue?vue&type=template&id=8b5dc1d6"
import script from "./InstallmentExtensionModal.vue?vue&type=script&lang=js"
export * from "./InstallmentExtensionModal.vue?vue&type=script&lang=js"
import style0 from "./InstallmentExtensionModal.vue?vue&type=style&index=0&id=8b5dc1d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports